import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-464bf412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sort" }
const _hoisted_2 = { class: "sort-title" }
const _hoisted_3 = {
  key: 0,
  class: "sort-list"
}
const _hoisted_4 = { class: "sort-list" }


import { i18n } from '@tencent/vb-web-base';
import { IRightSortConfig } from '@common/core/interface/IModel';
import RightItem from './RightItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortItem',
  props: {
    sort: null,
    action: null,
    beforeJump: null
  },
  setup(__props: any) {



const { getT } = i18n;
const $t = getT();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.sort.sortName), 1),
    (__props.sort.rights?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sort.rights, (item) => {
            return (_openBlock(), _createBlock(RightItem, {
              key: item.key,
              detail: item,
              action: __props.action,
              beforeJump: __props.beforeJump
            }, null, 8, ["detail", "action", "beforeJump"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.sort.chooseRights?.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("p", {
            class: _normalizeClass(["sort-tips", {'sort-tips_short': !__props.sort.rights?.length}])
          }, _toDisplayString(_unref($t)('以下权益{counts}选1', {counts: __props.sort.chooseRights.length})), 3),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sort.chooseRights, (item) => {
              return (_openBlock(), _createBlock(RightItem, {
                key: item.key,
                detail: item,
                type: "choose",
                sort: __props.sort,
                counts: __props.sort.chooseRights?.length,
                action: __props.action,
                beforeJump: __props.beforeJump
              }, null, 8, ["detail", "sort", "counts", "action", "beforeJump"]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})